import { Experiment, ExperimentClient, ExperimentConfig } from '@amplitude/experiment-js-client';

import { useIdentityStore } from '../lib/store';
import { fetchFeatureFlags } from './handlers/feature-flags';
import { fetchProfiles } from './handlers/profile';

type IdentifyConfig = {
	onError?: (...args: any[]) => void;
	isMobile?: boolean;
};

const handleFetchAppData = async (isMobile: boolean) => {
	const [{ company, user }, client] = await Promise.all([fetchProfiles(isMobile), fetchFeatureFlags()]);

	return { client, company, user };
};

export const identify = (token: string, { onError, isMobile = false }: IdentifyConfig = {}) => {
	useIdentityStore.setState({ onError, token });

	return handleFetchAppData(isMobile);
};

type InitializeConfig = {
	analyticsAPIKey?: string;
	analyticsServerURL?: string;
	experimentAPIKey?: string;
	experimentServerURL?: string;
};

const createExperimentClient = ({ experimentAPIKey, experimentServerURL }: InitializeConfig): ExperimentClient => {
	if (!experimentAPIKey) {
		throw new Error('No experiment API key provided');
	}

	const config: ExperimentConfig = {};

	if (experimentServerURL) {
		Object.assign(config, { serverUrl: experimentServerURL });
	}

	return Experiment.initialize(experimentAPIKey, config);
};

export const initialize = async (config: InitializeConfig) => {
	const experimentClient = createExperimentClient(config);

	useIdentityStore.setState({
		experimentClient,
		isInitialized: true,
		...config,
	});
};
